import styled from '@emotion/styled';

export const ChartWrapper = styled.div`
  background: #f6f7f8;
  border-radius: 8px;
  margin-top: 24px;
  width: 65%;
  padding: 36px 16px 24px 16px;
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-column-gap: 1%;
  grid-template-columns: 4% 19% 19% 19% 19% 19%;
  color: #637381;
  margin-bottom: 12px;
`;

export const ComputerWrapper = styled.div`
  height: 0px;
  width: 0px;
  overflow: hidden;
  padding-top: 10px;
  @media (min-width: 768px) {
    height: auto;
    width: auto;
  }
`;

export const BoldText = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

export const RowWrapper = styled.div`
  background-color: white;
  color: black;
  margin-top: 8px;
  display: grid;
  grid-column-gap: 1%;
  grid-template-columns: 4% 19% 19% 19% 19% 19%;
  padding: 24px 0px;
`;
